import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginFooterModule } from '../../shared/login-footer/login-footer.module';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { ResetPasswordComponent } from './reset-password.component';
import {
  AlertWarningModule,
  ButtonModule,
  FormAlertModule,
  InputModule
} from '@com-delta-idp/mnx-ui-kit';

@NgModule({
  declarations: [ResetPasswordComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoginHeaderModule,
    LoginFooterModule,
    InputModule,
    ButtonModule,
    AlertWarningModule,
    FormAlertModule
  ],
  exports: [ResetPasswordComponent]
})
export class ResetPasswordModule {}
